export default "__VITE_ASSET__7667da95__"